import { Link, NavLink } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

export default function Navbar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow">
            <div className="container">
                <Link className="navbar-brand fw-bold fs-3 text-danger d-flex align-items-center " to="/">
                    <img src="../images/logo.png" className="logoo" />
                    The Fitness Expert
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarContent">
                    <ul className="navbar-nav mx-auto">
                        <li className="nav-item">
                            <Link to="/" className="ms-1 nav-link">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/user/About" className="ms-1 nav-link">About</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/user/Programs" className="ms-1 nav-link">Programs</Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link to="/" className="nav-link dropdown-toggle ms-1" id="freeToolsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Free Tools</Link>
                            <ul className="dropdown-menu" aria-labelledby="freeToolsDropdown">
                                <li>
                                    <Link to="/user/Calorie" className="dropdown-item">🔥 Calorie Calculator</Link>
                                </li>
                                <li>
                                    <Link to="/user/Bmi" className="dropdown-item">📏 BMI Calculator</Link>
                                </li>
                                <li>
                                    <Link to="/user/ProteinCalculator" className="dropdown-item">💪 Protein Calculator</Link>
                                </li>
                            </ul>
                        </li>
                        {/* <li className="nav-item">
                            <Link to="/user/Calorie" className="nav-link ms-1">Calorie Calculator</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/user/ProteinCalculator" className="nav-link ms-1">Protein Calculator</Link>
                        </li> */}
                    </ul>
                    <div className="btn btn-danger p-0 m-0 mt-1 mb-1">
                        <Link to="/user/Contact" className="btn btn-danger">
                            Contact us
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
}